"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickOutsideHOC = void 0;
const React = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
function ClickOutsideHOC(WrappedComponent) {
    var _a;
    return _a = class ClickOutside extends React.Component {
            constructor() {
                super(...arguments);
                this.getRef = (ref) => {
                    this.ref = ref;
                };
                this.close = (e) => {
                    const { requestClose, visible } = this.props;
                    if (this.node &&
                        !this.node.contains(e.target) &&
                        visible &&
                        typeof requestClose === 'function') {
                        requestClose();
                    }
                };
            }
            componentDidMount() {
                if (this.ref) {
                    this.node = react_dom_1.default.findDOMNode(this.ref); // eslint-disable-line react/no-find-dom-node
                }
                document.addEventListener('mousedown', this.close);
            }
            componentWillUnmount() {
                document.removeEventListener('mousedown', this.close);
            }
            render() {
                return React.createElement(WrappedComponent, Object.assign({}, this.props, { ref: this.getRef }));
            }
        },
        _a.defaultProps = {
            visible: false,
            requestClose: () => { },
        },
        _a;
}
exports.ClickOutsideHOC = ClickOutsideHOC;
exports.default = ClickOutsideHOC;
